export const CASL_SET_RULES = 'CASL_SET_RULES'

